import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerfect = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.16406 2.38477C4.80092 2.38352 5.25774 2.45372 5.67969 2.66895C5.96802 2.81609 6.22367 3.02592 6.49609 3.26953C6.57938 3.2012 6.67166 3.12563 6.76465 3.05469C6.98286 2.88824 7.23316 2.72868 7.58203 2.60938C8.3802 2.33652 9.09979 2.32318 9.70508 2.54297C10.3132 2.76388 10.7553 3.20249 11.0225 3.7373C11.5476 4.78871 11.4117 6.21832 10.626 7.32422C10.0658 8.11169 9.70803 8.43282 8.97168 9.03809L8.96387 9.04492L8.95703 9.0498C8.18427 9.63746 7.62209 10.0645 6.73535 10.5527L6.49414 10.6855L6.25391 10.5527C5.09351 9.91578 4.28832 9.26232 3.36523 8.40039C2.47842 7.57242 1.73842 6.3442 1.66602 5.16797C1.62893 4.56537 1.7675 3.95787 2.17578 3.44824C2.58169 2.94176 3.21136 2.58463 4.05566 2.39648L4.10938 2.38477H4.16406Z",
		fill: "#6C9CFA",
		stroke: "#C4D7FD"
	})
});
export default SvgPerfect;
